
export const features = {
  list: [
    {
      text: `An aspiring Frontend Developer passionate about learning new skills and applying them through projects showcased on my GitHub.`,
    },
    {
      text: `Learning alone with the main support of <a href="LINK_PLACEHOLDER" class="about__link" target="_blank" rel="noopener noreferrer">Akademia Samouka</a> courses`,
      linkEducation: "https://www.akademiasamouka.pl",
    },
    {
      text: `In order to accelerate my learning of best practices, starting January 2025, I will be a mentee under the guidance of a <a href="LINK_PLACEHOLDER" class="about__link" target="_blank" rel="noopener noreferrer">Devmentor</a>. During this time, I will focus on mastering TypeScript and Next.js.`,
      linkEducation: "https://devmentor.pl/"
    },
    {
      text: `I am practicing English skills on <a href="LINK_PLACEHOLDER" class="about__link" target="_blank" rel="noopener noreferrer">Tutlo</a> platform`,
      linkEducation: "https://tutlo.com/pl/o-tutlo/"
    },
  ],
}

export default features
